import { useState, useEffect } from "react";

export function usePlatformStats() {
  const [platformStats, setPlatformStats] = useState(null);

  useEffect(() => {
    fetch("/api/public/stats")
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setPlatformStats)
      .catch(() => {});
  }, []);

  return platformStats;
}
